export function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = buildScript(src);
    script.onload = () => resolve();
    script.onerror = () => {
      diagnoseScriptLoadFailure(src).then(
        (reason) => reject(new Error(`Failed to load script: ${src} (${reason})`)),
        () => reject(new Error(`Failed to load script: ${src} (unknown reason)`)),
      );
    };

    if (document.body) {
      document.body.appendChild(script);
    } else {
      reject(new Error(`Missing document.body when loading script: ${src}`));
    }
  });
}

function diagnoseScriptLoadFailure(src: string): Promise<string> {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return Promise.resolve('browser is offline');
  }

  if (typeof fetch !== 'function') {
    return Promise.resolve('fetch unavailable, cannot diagnose further');
  }

  return fetch(src, { mode: 'no-cors', cache: 'no-store' })
    .then((response) => {
      if (response.type === 'opaque') {
        return 'network reachable but script blocked or errored — possible ad-blocker, browser extension, or Content Security Policy';
      }
      if (!response.ok) {
        return `HTTP ${response.status} ${response.statusText}`;
      }
      return 'network reachable but script failed to execute';
    })
    .catch((fetchError) => {
      const msg = fetchError instanceof Error ? fetchError.message : String(fetchError);
      return `network request failed: ${msg}`;
    });
}

function buildScript(src: string): HTMLScriptElement {
  const script = document.createElement('script');
  script.src = src;
  script.async = false;
  return script;
}
